import React from "react";

export const HorizontalLineColor = [
  "--neutral-greyscale-100",
  "--neutral-greyscale-200",
  "--neutral-greyscale-300",
] as const; // Använd `as const` för att göra det till en readonly tuple

export const HorizontalLineThickness = ["0.5px", "1px", "2px", "3px"] as const;
export const HorizontalLineMarginBottom = [
  "0px",
  "4",
  "8px",
  "10px",
  "16px",
] as const;

const HorizontalLine = ({
  color,
  thickness,
  marginBottom,
}: {
  color: (typeof HorizontalLineColor)[number];
  thickness: (typeof HorizontalLineThickness)[number];
  marginBottom?: (typeof HorizontalLineMarginBottom)[number];
}) => {
  return (
    <div
      style={{
        borderBottom: `${thickness} solid var(${color})`,
        width: "100%",
        marginBottom: marginBottom ? `${marginBottom}` : undefined,
      }}
    ></div>
  );
};

HorizontalLine.defaultProps = {
  color: "--neutral-greyscale-100",
  thickness: "1px",
};

export default HorizontalLine;
